import { Paper, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InstructionsMobileView from "./MobileView";
import InstructionsWebView from "./WebView";

const Instructions = () => {
  const theme = useTheme();
  const large = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Paper
      sx={{
        p: 2.5,
        width: "90%",
        // margin: "0 auto",
      }}
    >
      {large ? (
        <>
          <Typography sx={{ p: 2.5 }} variant="h6">
            Instructions on using this tool
          </Typography>
          <InstructionsWebView />
        </>
      ) : (
        <>
          <Typography sx={{ p: 1, fontWeight: "bold" }} variant="body1">
            Instructions on using this tool
          </Typography>
          <InstructionsMobileView />
        </>
      )}
    </Paper>
  );
};

export default Instructions;
